export const SET_AUTHTOKEN = 'SET_AUTHTOKEN';
export const SET_USER_DATA = 'SET_USER_DATA';
export const LOGOUT = 'LOGOUT';

export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
  return {
    type: SET_AUTHTOKEN,
    payload: token,
  };
};

export const setUserData = (data) => {
  localStorage.setItem('user', JSON.stringify(data));
  return {
  type: SET_USER_DATA,
  payload: data
  }
};

export const logout = () => {
  localStorage.clear()
  return {
    type: LOGOUT,
  };
};